import styled from "styled-components";
import theme from "../../../../styles/theme";

export const CardWrapper = styled.article`
  position: relative;
  width: 100%;
  max-width: 260px;

  @media ${theme.devices.tablet} {
    max-width: unset;
  }
`;

export const Badge = styled.div<{ $accentColor: string }>`
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background: ${(props) => props.$accentColor};
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 11px;
  font-family: ${theme.fonts.gilroySemiBold};
  z-index: 2;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
`;

export const CardContainer = styled.button<{
  $accentColor: string;
  $selected: boolean;
  $clickable: boolean;
}>`
  font-family: var(--font-sans);
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-top: 4px solid ${(props) => props.$accentColor};
  border-radius: 14px;
  padding: 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.05s ease,
    background-color 0.2s ease;
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};

  ${(props) =>
    props.$selected &&
    `
    border-color: ${props.$accentColor};
    background: #fbfdff;
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
  `}

  &:hover {
    border-color: ${(props) => props.$accentColor};
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
  }

  &:active {
    transform: scale(0.995);
  }
`;

export const Header = styled.header`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PlanTitle = styled.h3`
  font-family: var(--font-sans);
  font-weight: 700;
  font-size: 18px;
  color: #1F1F1F;
  margin: 0;
`;

export const PlanSubtitle = styled.p`
  font-family: var(--font-sans);
  font-weight: 400;
  font-size: 12px;
  color: #5f6368;
  margin: 0;
`;

export const PriceRow = styled.div`
  font-family: var(--font-sans);
  font-weight: 700;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  color: #1F1F1F;

  .currency {
    font-size: 14px;
    font-family: ${theme.fonts.gilroySemiBold};
  }

  .value {
    font-size: 28px;
    font-family: ${theme.fonts.gilroyBold};
  }

  .period {
    font-size: 14px;
    font-family: ${theme.fonts.gilroySemiBold};
    color: #5f6368;
  }
`;

export const PriceNote = styled.p`
  font-family: var(--font-sans);
  font-weight: 400;
  font-size: 12px;
  color: #5f6368;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #E2E6EA;
  margin: 4px 0 0 0;
`;

export const FeatureList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FeatureItem = styled.li<{
  $highlighted: boolean;
  $muted: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 8px;
  background: ${(props) => (props.$highlighted ? "#E8F5E9" : "transparent")};
  opacity: ${(props) => (props.$muted ? 0.45 : 1)};
`;

export const FeatureIcon = styled.span<{
  $accentColor: string;
  $muted: boolean;
}>`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  color: ${(props) => (props.$muted ? "#9aa0a6" : props.$accentColor)};
`;

export const FeatureText = styled.div`
  font-family: var(--font-sans);
  font-weight: 400;
  display: flex;
  flex-direction: column;
  text-align-last: left;
  .label {
    font-weight: 500;
  }

  .description {
    font-weight: 400;
  }
`;

export const ActionButton = styled.button<{ $accentColor: string }>`
  font-family: var(--font-sans);
  font-weight: 500;
  width: 100%;
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  background: ${(props) => props.$accentColor};
  color: #ffffff;
  font-family: ${theme.fonts.gilroySemiBold};
  font-size: 14px;
  cursor: pointer;
  transition:
    filter 0.2s ease,
    transform 0.05s ease;

  &:hover:enabled {
    filter: brightness(0.95);
  }

  &:active:enabled {
    transform: scale(0.99);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
